<template>
  <section class="form-list">
    <el-form
      class="form"
      ref="form"
      :rules="rules"
      :model="card"
      label-position="right"
      label-width="130px"
    >
      <el-form-item label="有效天数" prop="expire_days">
        <v-input-number
          class="w100"
          v-model="card.expire_days"
          placeholder="开卡后系统将根据有效天数自动计算出失效日期"
          type="unsignedSmallInt"
        />
      </el-form-item>
      <el-form-item label="失效日期" prop="expire_time">
        <el-date-picker
          v-model="card.expire_time"
          :picker-options="pickerOptions"
          class="date-picker"
          align="right"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          placeholder="选择日期时间"
          value-format="timestamp"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="所补差价">
        <v-input-money
          class="w100"
          v-model="card.update_payment"
          placeholder="请输入此次修改所补的差价，退款填写为负数即可"
          type="int"
          :is-show-suffix="true"
        />
      </el-form-item>
      <el-form-item v-if="+card.update_payment !== 0" label="补差价方式" prop="update_payment_mode">
        <v-select-card-payment-mode class="w100" v-model="card.update_payment_mode"/>
      </el-form-item>
      <el-form-item v-if="!isAdministrator" label="修改原因" prop="update_remark">
        <el-input
          v-model="card.update_remark"
          placeholder="请输入修改课卡的原因"
          maxlength="255"
        />
      </el-form-item>
      <el-form-item>
        <router-link v-if="card.card_del_apply_id" class="button-margin" :to="RouteConfig.cardDeleteApplyDetail.to(card.card_del_apply_id)">
          <el-button type="primary">退卡申请审核中，点击查看</el-button>
        </router-link>
        <router-link v-else-if="card.card_update_apply_id" class="button-margin" :to="RouteConfig.cardUpdateApplyDetail.to(card.card_update_apply_id)">
          <el-button type="primary">课卡修改审核中，点击查看</el-button>
        </router-link>
        <el-button v-else-if="card.is_reviewing" class="button-margin" :disabled="true" type="primary">修改申请审核中</el-button>
        <el-button v-else class="button-margin" :loading="isSaving" type="primary" @click="handleSubmit">
          {{ isAdministrator ? '保存' : '申请' }}修改
        </el-button>
        <el-button @click="RouteConfig.cardList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import cardPaymentModeIds from "@/enums/cardPaymentModeIds";
import { mapGetters } from 'vuex';
import { show, updateDate } from '@/api/card';
import { storeDate } from '@/api/card-update-apply';
import { toCent, toSecond } from "@/filters";
import { toMillisecond } from "@/utils/number";
import {paymentModes} from "@/enums/paymentModes";

export default {
  name: RouteConfig.cardEditDate.name,
  data: () => ({
    RouteConfig,
    isSearching: false,
    isSaving: false,
    keyword: '',
    checked_class_types: [],
    class_charge_types: [],
    stores: [],
    students: [],
    cardPaymentModes: [],
    card: {
      expire_days: '',
      expire_time: '',
      update_payment: '',
      update_remark: '',
      is_reviewing: 0,
      card_del_apply_id: 0,
      card_update_apply_id: 0,
      card_payment_mode_id: '',
      update_payment_mode: 0,
    },
    rules: {
      update_remark: [{ required: true, message: '请输入修改课卡的原因', trigger: 'change' }],
      update_payment_mode: [{ required: true, message: '请选择补差价付款方式', trigger: 'change' }],
    },
    pickerOptions: {
      disabledDate: (time) => time.getTime() < 0,
    },
    paymentModes,
    cardPaymentModeIds,
  }),
  computed: {
    ...mapGetters([ 'isAdministrator' ]),
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const { ...card } = this.card;
        card.card_id = this.id;
        card.expire_time = toSecond(card.expire_time);
        card.update_payment = toCent(card.update_payment);

        this.isSaving = true;
        const { isError } = this.isAdministrator
          ? await updateDate(this.id, card)
          : await storeDate(card);
        this.isSaving = false;

        if (!isError) this.isAdministrator ? RouteConfig.cardList.back() : RouteConfig.cardUpdateApplyList.push();
      });
    },
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      const expireTime = toMillisecond(data.expire_time);
      Object.assign(this.card, {
        expire_days: data.expire_days,
        expire_time: expireTime || '',
        is_reviewing: data.is_reviewing ? 1 : 0,
        card_del_apply_id: data.card_del_apply_id || 0,
        card_update_apply_id: data.card_update_apply_id || 0,
      });
    },
  },
};
</script>
